import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["field", "button"]

  static values = {
    fieldType: String,
    url: String,
    contextField: String,
    maxLength: Number,
    loadingText: { type: String, default: "Génération en cours..." },
    generationFailedText: { type: String, default: "Échec de la génération: %{error}" }
  }


  async generate(event) {
    event.preventDefault()

    const button = this.buttonTarget
    const field = this.fieldTarget
    const originalButtonHtml = button.innerHTML


    // Get context from nearby fields if available
    let context = ""
    if (this.contextFieldValue) {
      const contextField = document.querySelector(`#${this.contextFieldValue}`)
      if (contextField) {
        context = contextField.value || contextField.textContent || ""
      }
    }

    try {
      // Show loading state
      button.textContent = this.loadingTextValue
      button.disabled = true

      // Make API call
      const response = await fetch(this.urlValue, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({
          field_type: this.fieldTypeValue,
          context: context,
          max_length: this.hasMaxLengthValue ? this.maxLengthValue : null
        })
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json()

      if (data.success) {
        // Update the field with the generated text
        field.value = data.text

        // If there's a character counter, trigger an input event to update it
        field.dispatchEvent(new Event('input', { bubbles: true }))
      } else {
        console.error("AI generation failed:", data.error)
        const errorMessage = this.generationFailedTextValue.replace('%{error}', data.error)
        alert(errorMessage)
      }
    } catch (error) {
      console.error("Error generating text:", error)
    } finally {
      // Reset button state
      button.innerHTML = originalButtonHtml
      button.disabled = false
    }
  }
}
